import Database  from './model'
const {Get,Post ,Delete, uploadPost,Image} = Database();

export const LoginAdmin = async(FormData) => {
    let response = await Post({ url: 'admin/login', bodyData: FormData })
    return response;
}
export const deletepdfs = async(search)=>{
    console.log("url" , `admin/records/delete/${search}`);
    let response = await Delete({url : `admin/records/delete/` , id :search });
    return response;
}
export const uploadPdf = async(FormData)=>{
    let response = await uploadPost({url : 'admin/upload_pdf' , bodyData:FormData});
    return response;
}
export const getpdfs = async()=>{
   let response = await Get({ url: 'admin/getpdfdetails' })
   return response
}
export const GetTournaments = async(search) => {
    let response
    if (search === undefined) {
        response = await Get({ url: 'admin/tournament/get' })
    } else {
        response = await Get({ url: `admin/tournament/get?search=${search.data}`})
    }
    return response;
}
export const showedit = async(FormData)=>{
    let response = await Post({ url: 'admin/match/showedit',  bodyData: FormData
    })
    return response
}
export const GetGroups = async(formData) => {
    let response = await Post({ url: 'admin/group/get', bodyData: formData})
    return response; 
}

export const GetGroupList = async(formData) => {
    let response = await Post({ url: 'admin/group/list', bodyData: formData})
    return response; 
}

export const GetTournamentList = async() => {
    let response = await Get({ url: 'admin/tournament/list' })
    return response;
}

export const CreateTournament = async(formData) => {
    let response = await Post({ url: 'admin/tournament/create', bodyData: formData})
    return response; 
}

export const DeleteTournament = async(tournamentID) => {
    let response = await Get({ url: `admin/tournament/delete?id=${tournamentID.id}` })
    return response;
}

export const EditTournament = async(urlID) => {
    let response = await Get({ url: `admin/tournament/detail?id=${urlID.data}`})
    return response;
}

export const AvailableSlots = async() => {
    let response = await Post({ url: `player/available/slots`, bodyData: {}})
    return response;
}
export const TournamentDetail = async(userID) => {
    let response = await Get({ url: `admin/tournament/detail?id=${userID.id}` })
    return response;
}


export const CreateCorporate = async(formData) => {
    let response = await Image({ url: 'admin/teams/create', bodyData: formData})
    return response; 
}

export const GetCorporate = async(search) => {
    let response
    if (search === undefined) {
        response = await Get({ url: 'admin/teams/get' })
    } else {
        response = await Get({ url: `admin/teams/get?search=${search.data}`})
    }
    return response;
}

export const DeleteCorporate = async(corporateID) => {
    let response = await Get({ url: `admin/teams/delete?id=${corporateID.id}` })
    return response;
}

export const EditCorporate = async(urlID) => {
    let response = await Get({ url: `admin/teams/detail?id=${urlID.data}`})
    return response;
}

export const GetUsers = async(formData) => { 
    console.log("formData",formData)
    let response;
    if (formData.search === undefined || formData.search === null) {
        response = await Get({ url: `admin/user/get?role=${formData.type}&page=${formData.page}&limit=${formData.limit}&team=${formData.team}&gender=${formData.gender}` })
    } else {
        response = await Get({ url: `admin/user/get?role=${formData.type}&&search=${formData.search}`})
    }

    return response;
}

export const CreateUser = async(formData) => {
    let response = await Post({ url: 'admin/user/create', bodyData: formData})
    return response;
}

export const EditUser = async(urlID) => {
    let response = await Get({ url: `admin/user/detail?id=${urlID.data}`})
    return response;
}

export const DeleteUser = async(userID) => {
    let response = await Get({ url: `admin/user/delete?id=${userID.id}` })
    return response;
}


export const GetParticipantFilter = async(query) => {
    let response = await Get({ url: `admin/user/participant/filter?query=${query}` })
    return response;
}

// faq API
export const GetFaq = async(id) => { 
   let response = await Get({ url: `admin/faq/get?id=${id}`})

    return response;
}


export const CreateFaq = async(formData) => {
    let response = await Post({ url: 'admin/faq/create', bodyData: formData})
    return response;
}


export const EditFaq = async(urlID) => {
    let response = await Get({ url: `admin/faq/detail?id=${urlID.data}`})
    return response;
}

export const DeleteFaq = async(userID) => {
    let response = await Get({ url: `admin/faq/delete?id=${userID.id}` })
    return response;
}

export const DetailFaq = async(id) => {
    let response = await Get({ url: `admin/faq/detail?id=${id}`})
    return response;
}

// dynamic text API
export const GetDynamicText = async(type) => { 
    let response = await Get({ url: `admin/dynamic_text/get?type=${type}`})
 
     return response;
 }
 
 export const FilterDynamicText = async(FormData) => { 
    let response = await Post({ url: `admin/dynamic_text/filter`, bodyData: FormData})
 
     return response;
     ;
 }

 export const CreateDynamicText = async(formData) => {
     let response = await Post({ url: 'admin/dynamic_text/create', bodyData: formData})
     return response;
 }
 
 
 export const EditDynamicText = async(urlID) => {
     let response = await Get({ url: `admin/dynamic_text/detail?id=${urlID.data}`})
     return response;
 }
 
 export const DeleteDynamicText = async(userID) => {
     let response = await Get({ url: `admin/dynamic_text/delete?id=${userID.id}` })
     return response;
 }
 
 export const DetailDynamicText= async(id) => {
     let response = await Get({ url: `admin/dynamic_text/detail?id=${id}`})
     return response;
 }

 
export const GetParticipantList = async(userID) => {
    let response = await Get({ url: `admin/user/participant/list` })
    return response;
}

export const UserDetail = async(userID) => {
    console.log(userID)
    let response = await Get({ url: `admin/user/detail?id=${userID.id}&role=${userID.role? userID.role : null}` })
    return response;
}

export const Profile = async() => {
    let response = await Get({url: 'auth/profile'})
    return response;
}

export const GetScorers = async(search) => {
    let response = await Get({ url: 'admin/scorers/get' })
    return response;
}

export const AssignScorer = async(FormData) => {
    let response = await Post({ url: 'admin/match/assign', bodyData: FormData}) 
    return response;
}

export const GetTodayMatches = async() => {
    let  response = await Get({ url: 'admin/get_today_matches'})
    return response
}

export const SwapUser = async (FormData) => {
    let  response = await Post({ url: 'admin/match/swapuser', bodyData: FormData})
    return response
}

export const GetLogs = async (MatchID) => {
    let  response = await Get({ url: `admin/logs?match_id=${MatchID}` })

    return response
}

export const GetMatch = async (MatchID) => {
    let  response = await Get({ url: `admin/match-details?match_id=${MatchID}` })

    return response 
}

export const GetStandings = async (GroupID) => {
    let  response = await Get({ url: `admin/standings/get?group_id=${GroupID}` })

    return response
}
export const stagestatus = async(formData) => {
    let response = await Post({ url: 'admin/match/stagestatus', bodyData: formData });
    return response;
}
export const winnerdetails = async(FormData) => {
    let response = await Post({ url: 'admin/round_winner',  bodyData: FormData
    })
    return response
}

export const RoundMatchesAPI = async(FormData) => {
    let response = await Post({ url: 'admin/get_knockout_matches',  bodyData: FormData
    })
    return response
}
export const IsMatchDone = async(FormData) => {
    let response = await Post({ url: 'admin/match/ismatchdone',  bodyData: FormData
    })
    return response
}

export const SetMatchResult = async(FormData) => {
    let response = await Post({url:'scorer/set_match_result', bodyData:FormData});
    return response;
}

export const KnockoutStarted = async(FormData) => {
    let response = await Post({url:'admin/match/is_knockout', bodyData:FormData});
    return response;
}

export const submitScoreCard = async(FormData) => {
    let response = await Post({url:'admin/match/score', bodyData:FormData});
    return response;
}

export const GetBowlingMatch = async(FormData) => {
    let response = await Post({url:'admin/match/bowling_get', bodyData:FormData});
    return response;
}

export const Get2kMatch = async(FormData) => {
    let response = await Post({url:'admin/match/get_2k_match', bodyData:FormData});
    return response;
}

export const RoundConfig = async(FormData) => {
    let response = await Post({url:'admin/match/roundconfig', bodyData:FormData});
    return response;
}

export const SportsLogs = async(FormData) => {
    let response = await Post({url:'admin/match/submit_logs', bodyData:FormData});
    return response;
}

export const GetSportLogs = async(FormData) => {
    let response = await Post({url:'admin/match/showlogs', bodyData:FormData});
    return response;
}

export const userpaymentdetails = async(FormData)=>{
    let response = await Post({ url: 'admin/paymentdetails', bodyData:FormData})
    return response; 
}

export const UserPayment = async(FormData)=>{
    let response = await Post({ url: 'admin/user_payment', bodyData:FormData})
    return response; 
}

export const getEnrolledUserData = async(FormData) => {
    let response = await Post({ url: 'admin/get_enrolled', bodyData:FormData})
    return response;
}

export const playerPaymentDetails = async(FormData) => {
    let response = await Post({ url: 'admin/payment_detail', bodyData:FormData})
    return response;
}

export const getGamePricing = async() => {
    let response = await Get({ url: 'admin/game_pricing'})
    return response;
}
export const updatePricing = async(FormData) => {
    let response = await Post({ url: 'admin/update_pricing', bodyData: FormData})
    return response;
}

export const getSetting = async(FormData) => {
    let response = await Get({ url: 'admin/get_setting'})
    return response;
}
export const updatSetting = async(FormData) => {
    let response = await Post({ url: 'admin/update_setting', bodyData: FormData})
    return response;
}

export const SendAdminEmail = async(FormData) => {
    let response = await Post({ url: 'admin/send_admin_email', bodyData: FormData})
    return response;
}


export const CreateGallery = async(FormData) => {
    let response = await Image({ url: 'admin/gallery/create', bodyData: FormData})
    return response;
}
export const GetGallery = async (formData) => {
    let queryString = 'admin/gallery/get';

    if (formData) {
        queryString += '?filter=true';

        const { tournament_id, team_id, game_type } = formData;

        if (tournament_id) queryString += `&tournament_id=${tournament_id}`;
        if (team_id) queryString += `&team_id=${team_id}`;
        if (game_type) queryString += `&game_type=${game_type}`;
    }

    let response = await Get({ url: queryString });
    return response;
}

export const DetailGallery = async(urlID) => {
    let response = await Get({ url: `admin/gallery/detail?id=${urlID.data}`})
    return response;
}

export const DeleteGallery = async(GalleyData) => {
    let response = await Get({ url: `admin/gallery/delete?id=${GalleyData.id}` })
    return response;
}

export const TeamTopPerformer = async(SelectedTournament) => {
    let response = await Get({ url: `admin/team_performer?tournament_id=${SelectedTournament}` })
    return response;
}

export const GetPages = async(filter) => {
    const url = filter 
    ? `admin/content_manage/get?filter=${filter}`
    : `admin/content_manage/get`;
    let response = await Get({ url })
    return response;
}

export const CreatePages = async(formData) => {
    let response = await Post({ url: `admin/content_manage/create`, bodyData: formData })

    return response;
}

export const DeletePages = async() => {
    let response = await Get({ url: `admin/delete_pages` })
    return response;
}


export const DetailPages = async(urlID) => {
    let response = await Get({ url: `admin/content_manage/detail?id=${urlID.data}` })
    return response;
}


export const contactEmail = async(formData) => {
    let response = await Post({ url: `admin/contact-mail`, bodyData: formData })

    return response;
}

export const countBanner = async() => {
    let response = await Get({ url: `admin/count_banner`})

    return response;
}